"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardId = void 0;
const helper_1 = require("../../../common/helper");
const logic_types_1 = require("../logic-types");
class CardId {
    get type() {
        const value = this.id.substring(1);
        const cardValue = value.split(":")[0];
        return this.parseCardValue(cardValue);
    }
    get stringType() {
        switch (this.cardType) {
            case logic_types_1.CardType.Ace:
                return "A";
            case logic_types_1.CardType.King:
                return "K";
            case logic_types_1.CardType.Queen:
                return "Q";
            case logic_types_1.CardType.Jack:
                return "J";
            case logic_types_1.CardType.Ten:
                return "10";
            case logic_types_1.CardType.Nine:
                return "9";
            case logic_types_1.CardType.Eight:
                return "8";
            case logic_types_1.CardType.Seven:
                return "7";
            case logic_types_1.CardType.Six:
                return "6";
            case logic_types_1.CardType.Five:
                return "5";
            case logic_types_1.CardType.Four:
                return "4";
            case logic_types_1.CardType.Three:
                return "3";
            case logic_types_1.CardType.Two:
                return "2";
            default:
                (0, helper_1.assertNever)(this.cardType, "Invalid card type");
        }
    }
    get suit() {
        const type = this.id.substring(0, 1);
        switch (type) {
            case "C":
                return logic_types_1.CardSuit.Club;
            case "S":
                return logic_types_1.CardSuit.Spade;
            case "H":
                return logic_types_1.CardSuit.Heart;
            case "D":
                return logic_types_1.CardSuit.Diamond;
            default:
                throw new Error("Invalid CardSuit");
        }
    }
    get rawId() {
        // TODO: Include deck
        return this.cardType - 1 + this.cardSuit * 13;
    }
    get isRed() {
        return (this.cardSuit === logic_types_1.CardSuit.Heart || this.cardSuit === logic_types_1.CardSuit.Diamond);
    }
    get isAce() {
        return this.cardType === logic_types_1.CardType.Ace;
    }
    get isKing() {
        return this.cardType === logic_types_1.CardType.King;
    }
    get isValuedTen() {
        return (this.cardType === logic_types_1.CardType.King ||
            this.cardType === logic_types_1.CardType.Queen ||
            this.cardType === logic_types_1.CardType.Jack ||
            this.cardType === logic_types_1.CardType.Ten);
    }
    get blackjackValue() {
        switch (this.cardType) {
            case logic_types_1.CardType.Ace:
                return { minValue: 1, maxValue: 11 };
            case logic_types_1.CardType.King:
                return { minValue: 10, maxValue: 10 };
            case logic_types_1.CardType.Queen:
                return { minValue: 10, maxValue: 10 };
            case logic_types_1.CardType.Jack:
                return { minValue: 10, maxValue: 10 };
            case logic_types_1.CardType.Ten:
                return { minValue: 10, maxValue: 10 };
            case logic_types_1.CardType.Nine:
                return { minValue: 9, maxValue: 9 };
            case logic_types_1.CardType.Eight:
                return { minValue: 8, maxValue: 8 };
            case logic_types_1.CardType.Seven:
                return { minValue: 7, maxValue: 7 };
            case logic_types_1.CardType.Six:
                return { minValue: 6, maxValue: 6 };
            case logic_types_1.CardType.Five:
                return { minValue: 5, maxValue: 5 };
            case logic_types_1.CardType.Four:
                return { minValue: 4, maxValue: 4 };
            case logic_types_1.CardType.Three:
                return { minValue: 3, maxValue: 3 };
            case logic_types_1.CardType.Two:
                return { minValue: 2, maxValue: 2 };
            default:
                (0, helper_1.assertNever)(this.cardType, "Invalid card type");
        }
    }
    constructor(param) {
        if (typeof param === "string") {
            this.id = param;
            this.cardType = this.type;
            this.cardSuit = this.suit;
        }
        else if (typeof param === "number") {
            this.cardType = ((param % 13) + 1);
            const normalizedParam = param % 52;
            if (normalizedParam <= 12) {
                this.cardSuit = logic_types_1.CardSuit.Club;
            }
            else if (normalizedParam <= 25) {
                this.cardSuit = logic_types_1.CardSuit.Spade;
            }
            else if (normalizedParam <= 38) {
                this.cardSuit = logic_types_1.CardSuit.Heart;
            }
            else if (normalizedParam <= 51) {
                this.cardSuit = logic_types_1.CardSuit.Diamond;
            }
            else {
                throw new Error(`Invalid card type for raw value: ${param}`);
            }
            this.id = `${this.cardSuitToString(this.cardSuit)}${this.cardType}`;
        }
        else if (Array.isArray(param) &&
            param.length === 2 &&
            typeof param[0] === "number") {
            const [cardValue, cardSuit] = param;
            if (cardValue < logic_types_1.CardType.Ace ||
                cardValue > logic_types_1.CardType.King) {
                throw new RangeError(`${cardValue}`);
            }
            this.cardType = cardValue;
            this.cardSuit = cardSuit;
            this.id = `${this.cardSuitToString(this.cardSuit)}${this.cardType}`;
        }
        else {
            throw new Error("Invalid constructor arguments");
        }
    }
    equals(other) {
        return this.id === other.id;
    }
    parseCardValue(value) {
        // TODO: This has :{deck}
        const numValue = parseInt(value);
        if (!isNaN(numValue)) {
            return numValue;
        }
        throw new Error("Invalid CardValue");
    }
    cardSuitToString(suit) {
        switch (suit) {
            case logic_types_1.CardSuit.Club:
                return "C";
            case logic_types_1.CardSuit.Spade:
                return "S";
            case logic_types_1.CardSuit.Heart:
                return "H";
            case logic_types_1.CardSuit.Diamond:
                return "D";
            default:
                (0, helper_1.assertNever)(suit, "CardSuit not recognized");
        }
    }
}
exports.CardId = CardId;
